import React from "react";

interface CTAClusterProps {
  cta: {
    big: string;
    buttons: {
      waiver: string;
      coins: string;
      games: string;
    };
  };
  src?: string | null;
}

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, name: string, src?: string | null) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", `cta_${name}`, { source: src || undefined });
  }
};

const CTACluster: React.FC<CTAClusterProps> = ({ cta, src }) => (
  <section data-section="cta" className="py-8 md:py-12">
    <div className="max-w-2xl mx-auto px-4 text-center">
      <h2 className="text-2xl font-bold text-white mb-6">{cta.big}</h2>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a href="/waiver" className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold shadow" onClick={e => handleClick(e, "waiver", src)}>{cta.buttons.waiver}</a>
        <a href="/waiver" className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold shadow" onClick={e => handleClick(e, "coins", src)}>{cta.buttons.coins}</a>
        <a href="/games" className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold shadow" onClick={e => handleClick(e, "games", src)}>{cta.buttons.games}</a>
      </div>
    </div>
  </section>
);

export default CTACluster;
